const TAB_SF_ENV_KEY = "sfEnv";

/** The Salesforce environment this tab works in (chosen in the picker or from a link), or null. */
export function getTabSfEnv(): string | null {
  return sessionStorage.getItem(TAB_SF_ENV_KEY);
}

export function setTabSfEnv(env: string): void {
  sessionStorage.setItem(TAB_SF_ENV_KEY, env);
}

export function clearTabSfEnv(): void {
  sessionStorage.removeItem(TAB_SF_ENV_KEY);
}

/**
 * Reads an explicit Salesforce environment from a URL query string (`?sfEnv=...`).
 *
 * Honored only when the requested value matches one of the deployment's allowed environments
 * (`AVAILABLE_SF_ENVIRONMENTS`). This lets a shared test UI — one that can target more than one Salesforce
 * org (e.g. dev9 / qa2) — be pointed at the right org straight from the invite link, while a
 * single-environment deployment (e.g. production), whose allowed list won't contain the value, simply
 * ignores it. Anything absent or unrecognized returns null so the caller falls back to the env picker /
 * the deployment's configured default.
 *
 * @param search the URL query string (e.g. `window.location.search`)
 * @param available the deployment's allowed SF environments (`config.AVAILABLE_SF_ENVIRONMENTS`)
 * @returns the matched environment, or null
 */
export function pickSfEnvFromUrl(search: string, available: string[] | undefined): string | null {
  const requested = new URLSearchParams(search).get("sfEnv");
  if (!requested) return null;
  return (available ?? []).includes(requested) ? requested : null;
}
